<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div>
        <el-skeleton :rows="1" animated>
          <template #template>
            <el-skeleton-item variant="h1" style="width: 420px; height: 24px; margin-right: 8px;" />
            <el-skeleton-item variant="text" style="width: 260px; margin-top: 8px;" />
          </template>
        </el-skeleton>
      </div>
      <div>
        <el-skeleton :rows="0" animated>
          <template #template>
            <el-skeleton-item variant="button" style="width: 150px; height: 36px;" />
          </template>
        </el-skeleton>
      </div>
    </div>
    <div class="card-body">
      <div class="d-flex" style="gap: 16px; align-items: flex-start;">
        <!-- Left content -->
        <div style="flex: 1 1 0; min-width: 0;">
          <!-- Tabs bar -->
          <div style="margin-bottom: 12px;" class="d-flex">
            <el-skeleton :rows="0" animated>
              <template #template>
                <el-skeleton-item variant="rect" style="width: 180px; height: 36px; border-radius: 6px;" />
              </template>
            </el-skeleton>
          </div>
          <!-- Header info bar -->
          <div style="margin-bottom: 12px;">
            <el-skeleton-item variant="rect" style="width: 100%; height: 32px; border-radius: 6px;" />
          </div>
          <!-- Prompt box -->
          <div style="margin-bottom: 12px;">
            <el-skeleton-item variant="p" style="width: 100%; height: 44px; border-radius: 6px;" />
          </div>
          <!-- Audio bar -->
          <div style="margin-bottom: 12px;">
            <el-skeleton-item variant="rect" style="width: 320px; height: 40px; border-radius: 20px;" />
          </div>
          <!-- Criteria list (4 items) -->
          <div v-for="i in 4" :key="i" style="margin-bottom: 12px;">
            <el-skeleton-item variant="p" style="width: 100%; height: 92px; border-radius: 8px;" />
          </div>
          <!-- Scores row -->
          <div class="d-flex" style="gap: 12px; margin-top: 8px;">
            <el-skeleton-item v-for="i in 4" :key="'score-'+i" variant="rect" style="flex: 1; height: 44px; border-radius: 8px;" />
          </div>
        </div>
        <!-- Right evaluation panel -->
        <div style="width: 32%; min-width: 300px;">
          <div v-for="i in 4" :key="'panel-'+i" style="margin-bottom: 16px;">
            <div style="margin-bottom: 8px;">
              <el-skeleton-item variant="text" style="width: 70%; height: 18px;" />
            </div>
            <div class="d-flex" style="gap: 8px; margin-bottom: 8px;">
              <el-skeleton-item variant="rect" style="width: 90px; height: 24px; border-radius: 12px;" />
              <el-skeleton-item variant="rect" style="flex: 1; height: 32px; border-radius: 6px;" />
            </div>
            <el-skeleton-item variant="p" style="width: 100%; height: 80px; border-radius: 8px;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InspectionTaskDetailSkeleton',
}
</script>

<style scoped>
</style>


